import { render, staticRenderFns } from "./SociedadesFilter.vue?vue&type=template&id=2f277632"
import script from "./SociedadesFilter.vue?vue&type=script&lang=js"
export * from "./SociedadesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports